import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery, UseQueryResult } from 'react-query';
import {
  FolderAccessSettingsResponse,
  OemFolderAccessSettingsResponse,
} from './types';
import { folderAccessSettingsKeys } from 'app/pages/library/videos/videoList/components/folderAccessSettingsKeys';

const getFolderAccessSettingsOptions = async (
  folderId: number,
  forOem?: boolean
): Promise<FolderAccessSettingsResponse | OemFolderAccessSettingsResponse> => {
  if (folderId <= 0) {
    return {} as FolderAccessSettingsResponse | OemFolderAccessSettingsResponse;
  }

  const response = await EXPRESS_API.get(
    `/folders/${folderId}/access-settings/options?forOem=${forOem}`
  );
  return response.data;
};

// Overload signatures
export function useGetFolderAccessSettingsOptions(
  folderId: number,
  forOem: true
): UseQueryResult<OemFolderAccessSettingsResponse>;
export function useGetFolderAccessSettingsOptions(
  folderId: number,
  forOem?: false
): UseQueryResult<FolderAccessSettingsResponse>;

// Implementation
export function useGetFolderAccessSettingsOptions(
  folderId: number,
  forOem?: boolean
) {
  return useQuery([folderAccessSettingsKeys.options(folderId), forOem], () =>
    getFolderAccessSettingsOptions(folderId, forOem)
  );
}
